import { useAuthStore } from '@/stores/auth'
import { setCookie } from '@/services/cookies'
import { doRequest as baseDoRequest, STATUS_CODES } from './base'

const myBaseUrl = import.meta.env.VITE_DOMAIN_MY

export const enum REQUEST_METHODS {
  GET = 'get',
  POST = 'post',
  PATCH = 'patch',
  DELETE = 'delete'
}

export const doRequest = async (method: string, endpoint: string, data: any = {}): Promise<any> => {
  const result = await baseDoRequest(method, endpoint, data)

  if (result && result.error && result.status_code == STATUS_CODES.UNAUTHORIZED) {
    const authStore = useAuthStore()
    authStore.clear()
    setCookie('signInExpired', 'true')
    window.location.replace(`${myBaseUrl}/sign_in`)
  } else {
    return result
  }
}

export const doPost = async (endpoint: string, data: any = {}): Promise<any> => {
  return doRequest(REQUEST_METHODS.POST, endpoint, data)
}

export const doGet = async (endpoint: string): Promise<any> => {
  return doRequest(REQUEST_METHODS.GET, endpoint)
}

export const doPatch = async (endpoint: string, data: any = {}): Promise<any> => {
  return doRequest(REQUEST_METHODS.PATCH, endpoint, data)
}

export const doDelete = async (endpoint: string): Promise<any> => {
  return doRequest(REQUEST_METHODS.DELETE, endpoint)
}

export default {
  doGet,
  doPost,
  doPatch,
  doDelete,
  doRequest
}
